const auth = {
  getToken: () => {
    return localStorage.getItem("token") || "";
  },

  setToken: (token) => {
    return localStorage.setItem("token", token);
  },
};

export default auth;
